import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import { ROUTE_ENUM } from './RoutesConstant';
import { isLogoutInProgress } from '../utils/sessionLogout';

export default function ProtectedRoute({ children, skipProtection = false }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();
  const logoutInProgress = isLogoutInProgress();

  useEffect(() => {
    let isMounted = true;

    if (logoutInProgress) {
      setIsAuthenticated(false);
      return () => {
        isMounted = false;
      };
    }

    if (skipProtection) {
      return () => {
        isMounted = false;
      };
    }

    const checkAuthStatus = async () => {
      try {
        const result = await authService.checkAuthStatus();
        if (isMounted) setIsAuthenticated(!!result);
      } catch {
        if (isMounted) setIsAuthenticated(false);
      }
    };

    checkAuthStatus();

    const onStorage = (e) => {
      if (
        e.key === 'amplify-authenticator-authState' ||
        e.key === 'amplify-signin-with-hostedUI' ||
        e.key === 'rapchik_logout_in_progress'
      ) {
        if (isLogoutInProgress()) {
          setIsAuthenticated(false);
          return;
        }
        checkAuthStatus();
      }
    };

    window.addEventListener('storage', onStorage);

    return () => {
      isMounted = false;
      window.removeEventListener('storage', onStorage);
    };
  }, [location.pathname, logoutInProgress, skipProtection]);

  if (skipProtection) {
    return children;
  }

  if (isAuthenticated === null && !logoutInProgress) {
    return (
      <div style={{ textAlign: 'center', marginTop: '20vh', fontSize: 24 }}>
        Loading...
      </div>
    );
  }

  if (location.pathname === ROUTE_ENUM.ROOT.routePath) {
    if (isAuthenticated && !logoutInProgress) {
      return <Navigate to={ROUTE_ENUM.SELECT_GAME.routePath} replace />;
    }
    return <Navigate to={ROUTE_ENUM.AUTH_LOGIN.routePath} replace />;
  }

  if (location.pathname === ROUTE_ENUM.AUTH_LOGIN.routePath) {
    if (isAuthenticated && !logoutInProgress) {
      return <Navigate to={ROUTE_ENUM.SELECT_GAME.routePath} replace />;
    }
    return children;
  }

  if (logoutInProgress || (!isAuthenticated && !skipProtection)) {
    return (
      <Navigate
        to={ROUTE_ENUM.AUTH_LOGIN.routePath}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return children;
}
